export const getBookName = () => {
  if (process.env.NODE_ENV !== 'production') {
    return 'ja-i-mog'
  } else {
    const [bookName] = window.location.hostname.split('.')
    return bookName;
  }
}